import React from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import FacebookSvg from "../../../../icons/socialmedia/FacebookSvg";
import LinkedinSvg from "../../../../icons/socialmedia/LinkedinSvg";
import CopySvgIcon from "../../../../icons/socialmedia/CopySvgIcon";
import { SetStateAction, useState, useEffect } from "react";
interface props {
  className?: string;
  setShowCopiedPopup: React.Dispatch<SetStateAction<boolean>>;
  showCopiedPopup?: boolean;
}

export const BlogsSocialMediaIcons = ({
  className,
  setShowCopiedPopup,
  showCopiedPopup,
}: props) => {
  const handleCopy = () => {
    setShowCopiedPopup(true);
    setTimeout(() => {
      setShowCopiedPopup(false);
    }, 1000);
    window.navigator.clipboard.writeText(window.location.href);
  };
  return (
    <div className={`${className} flex py-4 lg:py-5`}>
      <a
        className="px-5"
        href={`https://www.facebook.com/sharer.php?u=${window.location.href}`}
        target="blank"
      >
        <FacebookSvg fill="#262626" className="h-5 w-5 lg:h-6 lg:w-6" />
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
        target="blank"
        className="border-r-[1px] border-l-[1px] px-5"
      >
        <LinkedinSvg fill="#262626" className="h-5 w-5 lg:h-6 lg:w-6" />
      </a>
      <Button
        className="px-5"
        variant={"custom"}
        size={"custom"}
        onClick={handleCopy}
      >
        <CopySvgIcon />
      </Button>
    </div>
  );
};

export default BlogsSocialMediaIcons;
